import { lazy } from 'react'

export default (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      localStorage.getItem('page-has-been-force-refreshed') || 'false',
    )

    try {
      const component = await componentImport()

      localStorage.setItem('page-has-been-force-refreshed', 'false')

      return component
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        localStorage.setItem('page-has-been-force-refreshed', 'true')
        window.location.reload()
        throw new Error('Force reloading page due to lazy load failure')
      }

      throw error
    }
  })
